export enum ERaceConfigSwitch {
  FollowPrices = 'FollowPrices',
  Suspended = 'Suspended',
}
